import {
  Alert,
  AlertDescription,
  AlertTitle,
  Button,
} from '@cardboard-ui/react';
import { t } from '@lingui/macro';
import React from 'react';
import { InfoIcon } from 'components/icons';

interface SuccessfullySubmittedFormAlertProps {
  onSuccess: () => void;
}

export const SuccessfullySubmittedFormAlert = ({
  onSuccess,
}: SuccessfullySubmittedFormAlertProps) => {
  return (
    <Alert
      status="success"
      variant="subtle"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      textAlign="center"
      p={6}
      borderRadius="lg"
    >
      <InfoIcon size="4x" />
      <AlertTitle
        mt={6}
        mb={1}
        fontSize="lg"
      >{t`Thanks for answering!`}</AlertTitle>
      <AlertDescription maxWidth="sm">
        {t`You can respond again by clicking the button below.`}
      </AlertDescription>
      <Button
        onClick={onSuccess}
        my={2}
        size="sm"
        colorScheme="green"
      >{t`Submit another response`}</Button>
    </Alert>
  );
};
